// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__3oN7L","unreadBadge":"styles_unreadBadge__2b2EN","modalContent":"styles_modalContent__2rFM5","modal":"styles_modal__3ol2J"};